// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"173":"wiki-tools","284":"data-table","660":"yeti"}[chunkId] + "." + {"173":"9ae53590","284":"7a2dd8d5","660":"a27ef302"}[chunkId] + ".css";
};